mutation generateSlotImage($input: SlotRefInput!) {
  slot: generateSlotImage(input: $input) {
    id
    imageUrl
    textStatus
    status
  }
}
